import {NgModule} from '@angular/core';
import {CommonModule, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatButtonModule} from '@angular/material/button';

import {PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {AppComponent} from './app.component';
// Import containers
import {DefaultLayoutComponent} from './containers';

import {P404Component} from './views/error/404.component';
import {P500Component} from './views/error/500.component';
import {RegisterComponent} from './views/register/register.component';
import {
    AppAsideModule,
    AppBreadcrumbModule,
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
} from '@coreui/angular';
// Import routing module
import {AppRoutingModule} from './app.routing';
// Import 3rd party components
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {ChartsModule} from 'ng2-charts';
import {LoginComponent} from "./components/login/login.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {ConfirmEmailComponent} from './components/confirm-email/confirm-email.component';
import {ForgotPasswordComponent} from './components/forgot-password/forgot-password.component';
import {ChangePasswordComponent} from './components/change-password/change-password.component';
import {
    SproutFormsLibraryModule
} from '../../../../../../sprout-forms/projects/sprout-forms-library/src/lib/sprout-forms-library.module';
import {FormListComponent} from './components/forms/form-list/form-list.component'
import {AlertModule, ModalModule} from "ngx-bootstrap";
import {ImportSproutComponent} from './components/forms/import-sprout/import-sprout.component';
import {UploadModule} from "./modules/upload/upload.module";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatRadioModule} from "@angular/material/radio";
import {ProcessBuilderComponent} from "./components/forms/process-builder/process-builder.component";
import {MatTreeModule} from "@angular/material/tree";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatCardModule} from "@angular/material/card";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {ProcessConfigComponent} from './components/forms/process-config/process-config.component';
import {MatDialogModule} from "@angular/material/dialog";
import {JOLTComponent} from './components/forms/builder/designers/jolt/jolt.component';
import {AngularSplitModule} from "angular-split";
import {PrettyJSONPipe} from './pretty-json.pipe';
import {MonacoEditorModule, NgxMonacoEditorConfig} from "ngx-monaco-editor";
import {TranslationComponent} from './components/forms/builder/designers/translation/translation.component';
import {HandlebarsComponent} from './components/forms/builder/designers/handlebars/handlebars.component';
import {MatTableModule} from "@angular/material/table";
import {SafeHtmlPipe} from './pipes/safe-html.pipe';
import {MatMenuModule} from "@angular/material/menu";
import {MatToolbarModule} from "@angular/material/toolbar";
import {ProcessTranslationsComponent} from './components/forms/process-translations/process-translations.component';
import {FormGroupTestComponent} from './deleteme/form-group-test/form-group-test.component';
import {Html2PDFComponent} from './components/forms/builder/designers/html2-pdf/html2-pdf.component';
import {FormOutputComponent} from './components/forms/builder/designers/form-output/form-output.component';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {PdfViewerModule} from "ng2-pdf-viewer";
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import {HomeComponent} from './components/home/home.component';
import {MatGridListModule} from "@angular/material/grid-list";
import {
    ImportTranslationMessageDialogComponent
} from './components/import-translation-message-dialog/import-translation-message-dialog.component';
import {NgIdleKeepaliveModule} from "@ng-idle/keepalive";
import {MomentModule} from "angular2-moment";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

const monacoConfig: NgxMonacoEditorConfig = {
    baseUrl: '/monaco/assets',
};

@NgModule({
    imports: [
        MatButtonModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        AppAsideModule,
        AppBreadcrumbModule.forRoot(),
        AppFooterModule,
        AppHeaderModule,
        AppSidebarModule,
        PerfectScrollbarModule,
        BsDropdownModule.forRoot(),
        TabsModule.forRoot(),
        ChartsModule,
        SproutFormsLibraryModule,
        UploadModule,
        ModalModule.forRoot(),
        AlertModule.forRoot(),
        MatIconModule,
        MatTooltipModule,
        MatRadioModule,
        MatTreeModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        MatCardModule,
        MatSelectModule,
        MatDialogModule,
        AngularSplitModule.forRoot(),
        MonacoEditorModule.forRoot(monacoConfig),
        MatTableModule,
        MatMenuModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        PdfViewerModule,
        NgxExtendedPdfViewerModule,
        MatGridListModule,
        NgIdleKeepaliveModule.forRoot(),
        MomentModule,
    ],
  exports: [
    SproutFormsLibraryModule
  ],
  declarations: [
    AppComponent,
      LoginComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    RegisterComponent,
    ConfirmEmailComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    FormListComponent,
    ImportSproutComponent,
    ProcessBuilderComponent,
    ProcessConfigComponent,
    JOLTComponent,
    PrettyJSONPipe,
    TranslationComponent,
    HandlebarsComponent,
    SafeHtmlPipe,
    ProcessTranslationsComponent,
    FormGroupTestComponent,
    Html2PDFComponent,
    FormOutputComponent,
    HomeComponent,
    ImportTranslationMessageDialogComponent,
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
  }, SproutFormsLibraryModule
  ],
  bootstrap: [ AppComponent ],
    entryComponents: [ProcessConfigComponent, ProcessTranslationsComponent, ImportTranslationMessageDialogComponent]
})
export class AppModule { }
